var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "An\\xE1lise",
    transform: "translate(-247 -403)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 50,
    height: 40,
    transform: "translate(247 403)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_739",
    "data-name": "Grupo 739",
    transform: "translate(-4.999 -4.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_271",
    "data-name": "Subtra\\xE7\\xE3o 271",
    d: "M27.5,40h-3a.5.5,0,0,1-.5-.5v-22A1.5,1.5,0,0,1,25.5,16h1A1.5,1.5,0,0,1,28,17.5v22A.5.5,0,0,1,27.5,40Zm-8,0h-3a.5.5,0,0,1-.5-.5V12.166a1.5,1.5,0,0,1,1.5-1.5h1a1.5,1.5,0,0,1,1.5,1.5V39.5A.5.5,0,0,1,19.5,40Zm-8,0h-3a.5.5,0,0,1-.5-.5V33.752A9.715,9.715,0,0,0,8,20.38V6.833a1.5,1.5,0,0,1,1.5-1.5h1a1.5,1.5,0,0,1,1.5,1.5V39.5A.5.5,0,0,1,11.5,40Zm-8,0H.5a.5.5,0,0,1-.5-.5V36.754c.305.029.62.045.935.045A9.69,9.69,0,0,0,4,36.3v3.2A.5.5,0,0,1,3.5,40ZM.935,31.351a4.293,4.293,0,0,1-.935-.1V22.884a4.292,4.292,0,0,1,.935-.1A4.251,4.251,0,0,1,4,24.075v5.983A4.251,4.251,0,0,1,.935,31.351ZM4,17.829H4a9.69,9.69,0,0,0-3.064-.494c-.312,0-.626.015-.935.045V1.5A1.5,1.5,0,0,1,1.5,0h1A1.5,1.5,0,0,1,4,1.5V17.827Z",
    transform: "translate(268.999 407.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_242",
    "data-name": "Uni\\xE3o 242",
    d: "M0,12.732A8.263,8.263,0,0,1,13.181,6.088l5.73-5.73a1.224,1.224,0,0,1,1.731,1.731l-5.73,5.73A8.266,8.266,0,1,1,0,12.732Zm2.362,0a5.905,5.905,0,1,0,10.4-3.825l-.672-.672a5.9,5.9,0,0,0-9.729,4.5Z",
    transform: "translate(277.999 447.999) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.9b762c4cf02614454dad2f03fc76cb6a.svg";
export { ForwardRef as ReactComponent };